import Box from "@/components/Box";
import ToggleSwitch from "@/tpo/ToggleSwitch";

const KeyToggleButton = ({ showKey, onChange, controlsId }) => {
  const toggleId = `${controlsId}-toggle`;

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      gap={10}
      lineHeight="normal"
      aria-controls={controlsId}
    >
      <Box
        as="label"
        htmlFor={toggleId}
        fontFamily="gilroyBold"
        fontSize={14}
        lineHeight="24px"
        color="dark"
        style={{ cursor: "pointer" }}
      >
        Show key
      </Box>
      <ToggleSwitch id={toggleId} value={showKey} onChange={onChange} offBg="haze" />
    </Box>
  );
};

export default KeyToggleButton;
